import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { TFunction } from 'i18next';
import React from 'react';

import { WarningModalType } from 'components/TravellerInformationForm/hooks/useReservation';

type FrankfurtModalType = {
  t: TFunction;
};

export function getFrankfurtLoungeModal({ t }: FrankfurtModalType): WarningModalType {
  return {
    children: (
      <ElementsSDK.Typography
        variant="p1"
        dangerouslySetInnerHTML={{
          __html: t('tip.loungeForm.frankfurt.modal.text'),
        }}
      />
    ),
  };
}
